import { apiClient } from "./api";

export interface OAuthUrlResponse {
  url: string;
}

export interface OAuthCallbackRequest {
  code: string;
}

export interface OAuthVerifyRequest {
  access_token: string;
}

export interface OAuthResponse {
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
    avatarUrl?: string;
    createdAt: string;
  };
  access_token: string;
}

// OAuth API service
export const oauthApi = {
  // Get Google OAuth URL
  async getGoogleAuthUrl(): Promise<OAuthUrlResponse> {
    const response = await apiClient.get<OAuthUrlResponse>(
      "/auth/oauth/google/url"
    );
    return response;
  },

  // Handle Google OAuth callback
  async handleGoogleCallback(code: string): Promise<OAuthResponse> {
    const response = await apiClient.post<OAuthResponse>(
      "/auth/oauth/google/callback",
      {
        code,
      }
    );
    return response;
  },

  // Verify Google OAuth token
  async verifyGoogleToken(token: string): Promise<OAuthResponse> {
    const response = await apiClient.post<OAuthResponse>(
      "/auth/oauth/google/verify",
      {
        access_token: token,
      }
    );
    return response;
  },

  // Handle Supabase OAuth callback
  async handleSupabaseCallback(accessToken: string): Promise<OAuthResponse> {
    const response = await apiClient.post<OAuthResponse>(
      `/auth/oauth/google/supabase-callback?access_token=${accessToken}`
    );
    return response;
  },
};
